document.addEventListener('DOMContentLoaded', function () {
  // Seleciona o input e o botão que já existem no HTML do carrinho
  const inputCoupon = document.querySelector('#CartDiscountcode');
  const applyButton = document.querySelector('.apply-btn');
  const couponMessage = document.querySelector('#coupon-message'); 
  // ^ Este #coupon-message será uma div que vai exibir "Cupom aplicado" ou "Cupom inválido"

  // Se não encontrar, sai
  if (!inputCoupon || !applyButton) return;

  // Quando clicar no botão, salva o cupom no localStorage e redireciona
  applyButton.addEventListener('click', function () {
    const couponCode = inputCoupon.value.trim();
    if (!couponCode) {
      if (couponMessage) {
        couponMessage.style.color = 'red';
        couponMessage.innerText = 'Por favor, insira um cupom.';
      }
      return;
    }
    // Salva o cupom no localStorage para conferirmos depois
    localStorage.setItem('desired_coupon', couponCode);

    // Redireciona para /discount/CUPOM?redirect=/cart
    window.location.href = `/discount/${encodeURIComponent(couponCode)}?redirect=/cart`;
  });

  // Ao recarregar a página do carrinho, verificamos se “desired_coupon” existe
  const couponWeWanted = localStorage.getItem('desired_coupon');
  if (couponWeWanted) {
    // Verifica se o carrinho tem algum discount com esse title
    // Normalmente, no cart.liquid, existe [data-cart-discounts] listando títulos dos cupons
    const discountArea = document.querySelector('[data-cart-discounts]');

    if (discountArea) {
      // Se naquela área contém o nome do cupom, consideramos "cupom válido"
      if (discountArea.innerText.toLowerCase().includes(couponWeWanted.toLowerCase())) {
        if (couponMessage) {
          couponMessage.style.color = 'green';
          couponMessage.innerText = 'Cupom aplicado com sucesso!';
        }
      } else {
        if (couponMessage) {
          couponMessage.style.color = 'red';
          couponMessage.innerText = 'Cupom inválido ou não se aplica a estes itens.';
        }
      }
    }
    // Remove do localStorage para não ficar repetindo sempre
    localStorage.removeItem('desired_coupon');
  }
});

